import { render, staticRenderFns } from "./AudienceNotAvailable.vue?vue&type=template&id=4bb1638e&scoped=true&"
import script from "./AudienceNotAvailable.vue?vue&type=script&lang=js&"
export * from "./AudienceNotAvailable.vue?vue&type=script&lang=js&"
import style0 from "./AudienceNotAvailable.vue?vue&type=style&index=0&id=4bb1638e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1638e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VImg,VLayout})
